import styled from "styled-components/macro";
import Button from "ui/Button";
import Typography from "ui/Typography";
import { $HeadingsWrapper } from "templates/InboxLayout";

const COLLAPSIBLE_CONTAINER_BREAKPOINT = "60.5rem";

export const $ExpandHeadingWrapper = styled($HeadingsWrapper)`
  @media screen and (${({ theme }) => theme.BreakpointPhoneDown}) {
    text-align: center;
  }
`;

// negative margin to offset the margin that comes with the library cards
export const $ExpandButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: -15px;
  @media screen and (max-width: ${COLLAPSIBLE_CONTAINER_BREAKPOINT}) {
    justify-content: flex-start;
    margin-top: 0;
  }

  @media screen and (${({ theme }) => theme.BreakpointPhoneUp}) {
    width: 100%;
  }
`;

export const $ExpandButton = styled(Button)`
  padding-right: 0;
  padding-top: 0;
  @media screen and (max-width: ${COLLAPSIBLE_CONTAINER_BREAKPOINT}) {
    background: ${({ theme }) => theme.ColorSneaker100};
    width: 100%;
    max-width: 18.5rem;
    border-radius: 1rem;
    margin-left: 0.5rem;
    padding: 3px 2rem;
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: none;
    }
  }
`;

export const $ExpandPillButton = styled(Button).attrs({
  block: true,
})`
  margin: 1rem auto 2rem;
  min-height: 2.25rem;
  padding-top: 0;
  padding-bottom: 0;
  background-color: ${({ theme }) => theme.ColorWhite};
  border: 1px solid ${({ theme }) => theme.ColorSpace100};
  &:hover,
  &:active,
  &:focus {
    span {
      color: ${({ theme }) => theme.ColorBlurple500} !important;
    }
    path {
      fill: ${({ theme }) => theme.ColorBlurple500} !important;
    }
  }
`;

export const $ContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: ${({ theme }) => theme.SizeXl};

  @media screen and (${({ theme }) => theme.BreakpointPhoneDown}) {
    margin: 0;
    justify-content: center;
  }

  @media screen and (max-width: ${COLLAPSIBLE_CONTAINER_BREAKPOINT}) {
    max-width: 375px;
    margin: 0 auto;
  }
`;

/**
 * When using a tooltip it will try to center on element.
 * Since header elements are block and fill the line, the
 * tooltip will be positioned incorrectly.
 */
export const $InlineTypography = styled(Typography)`
  display: inline-block;
`;

export const $IconContainer = styled.div`
  display: inline-block;
  margin-left: 0.6rem;
  & > svg {
    width: 1rem;
    height: 1rem;
    margin-bottom: 0.18rem;
  }
`;
